export enum UsageProvider {
  SERPAPI = "serpapi",
  SCRAPERAPI = "scraperapi",
  BROWSERBASE = "browserbase",
  APIFY = "apify",
  PACER = "pacer",
}
